import { urlBase } from "./urlConfig";

export const imgLogoLogin = urlBase + "/img/logo_slogan_azul.png";
export const imgLogoMeditoc = urlBase + "/img/meditoc_azul.svg";
export const imgLogoMeditocCasa = urlBase + "/img/LogoMeditocCasa.svg";
